var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showIpAccess)?_c('a',{attrs:{"href":_vm.ipAccessHref}},[_c('i',{staticClass:"fa-light me-1",class:_vm.ipAccessStyleClass}),_vm._v(_vm._s(_vm.ipAccessText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }